import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from './app/App'
import { EventOperatorApp } from './app/EventOperatorApp'
import { EventCashierStableApp } from './app/EventCashierStableApp'
import { CrossRoleOperations,RoleActionLauncher } from './app/CrossRoleOperations'
import { CustomerOrdering } from './modules/customer-ordering/CustomerOrdering'
import { ProductionSettings } from './modules/production/ProductionSettings'
import { applyEventPwaIdentity } from './core/pwa/eventPwaIdentity'
import { PwaInstallButton } from './core/pwa/PwaInstallButton'
import { supabase } from './adapters/database/supabaseClient'
import { parseNexiApp2AppCallback, isValidNexiApp2AppCallback } from './modules/payments/nexiApp2AppCallback'
import './app/styles.css'
import './modules/catalog-builder/catalogBuilder.css'
import './modules/cash-register/cashRegister.css'
import './modules/production/production.css'
import './modules/orders/orders.css'
import './modules/dashboard/dashboard.css'
import './modules/customer-ordering/customerOrdering.css'
import './app/operationalLight.css'
import './app/unifiedLight.css'

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => navigator.serviceWorker.register('/sw.js?v=2.9.1', { updateViaCache: 'none' }).then(reg => reg.update()).catch(() => undefined))
}

const UUID_PATTERN = '[0-9a-f-]{36}'
let path = window.location.pathname
const staleOperationalRoute = path.match(new RegExp(`^/(e|operator|cassa)/(${UUID_PATTERN})/?$`, 'i'))
if (staleOperationalRoute) {
  try {
    const { data } = await supabase.rpc('resolve_event_route', { target_event_id: staleOperationalRoute[2] })
    const canonicalEventId = typeof data === 'string' ? data : null
    if (canonicalEventId && canonicalEventId !== staleOperationalRoute[2]) {
      path = `/${staleOperationalRoute[1]}/${canonicalEventId}`
      window.history.replaceState(null, '', `${path}${window.location.search}${window.location.hash}`)
    }
  } catch { /* route recovery is best-effort; normal error handling remains available */ }
}
const params = new URLSearchParams(window.location.search)
// Keep the Nexi callback inside the installed operational PWA's URL scope.
// The embedded role/event path is also recoverable when Android opens Chrome,
// whose sessionStorage can be separate from the installed PWA.
const scopedNexiReturn=path.match(new RegExp(`^/(cassa|operator)/(${UUID_PATTERN})/nexi-pos-return/?$`,'i'))
if(path==='/nexi-pos-return'||scopedNexiReturn){
 const callback=parseNexiApp2AppCallback(params)
 const {callerTrxId,actionCode,result,amount,terminalId,authorizationNumber}=callback
 let pending:{eventId?:string;kind?:string;returnPath?:string}|null=null
 try{const stored=sessionStorage.getItem('event-platform:nexi-pos-pending');pending=stored?JSON.parse(stored):null}catch{ /* Android may launch a different browser storage context */ }
 const scopedKind=scopedNexiReturn?.[1],scopedEventId=scopedNexiReturn?.[2]
 const fallback=pending?.kind==='operator'?'/operator/':'/cassa/'
 const target=scopedKind&&scopedEventId?`/${scopedKind}/${scopedEventId}`:pending?.eventId?fallback+pending.eventId:pending?.returnPath?.startsWith('/')?pending.returnPath:'/'
 const redirect=(status:'paid'|'failed',message?:string)=>{
  const key=status==='paid'?'nexi_pos_paid':'nexi_pos_failed'
  window.location.replace(target+(target.includes('?')?'&':'?')+key+'=1'+(message?'&nexi_pos_message='+encodeURIComponent(message):''))
 }
 try{
  if(!isValidNexiApp2AppCallback(callback)){
   redirect('failed','Ritorno Nexi incompleto: ordine non confermato. Controlla l’esito nell’app Nexi prima di riprovare.')
  }else{
   // Nexi may omit amount/actionCode on cancellations (result=20).
   // Non-approved returns must never confirm an order.
   const {data,error}=await supabase.rpc('confirm_nexi_app2app_callback',{
    target_caller_trx_id:callerTrxId,target_result:result,target_action_code:actionCode,target_amount:Number.isFinite(amount)?amount:-1,
    target_terminal_id:terminalId,target_authorization_number:authorizationNumber
   })
   if(error)throw error
   const response=data as {paid?:boolean;eventId?:string;kind?:string}
   if(response?.paid){try{sessionStorage.removeItem('event-platform:nexi-pos-pending')}catch{}}
   const base=response?.kind==='operator'?'/operator/':'/cassa/'
   const destination=scopedEventId?target:response?.eventId?base+response.eventId:target
   const success=Boolean(response?.paid)
   const message=success?'':result===20?'Pagamento Nexi annullato. L’ordine resta non pagato.':'Pagamento Nexi non confermato. Verifica l’esito prima di riprovare.'
   window.location.replace(destination+(destination.includes('?')?'&':'?')+(success?'nexi_pos_paid=1':'nexi_pos_failed=1')+(message?'&nexi_pos_message='+encodeURIComponent(message):''))
  }
 }catch(e){
  redirect('failed',e instanceof Error?e.message:'Errore verifica Nexi: ordine non confermato')
 }
}
if(path==='/payment-return'&&(params.get('nexi_return')==='1'||params.get('nexi_cancel')==='1')){
 try{const raw=sessionStorage.getItem('event-platform:nexi-pending');const pending=raw?JSON.parse(raw) as {returnPath?:string;eventId?:string;kind?:string}:null;const fallback=pending?.kind==='cashier'?'/cassa/':pending?.kind==='operator'?'/operator/':'/e/';const target=typeof pending?.returnPath==='string'&&pending.returnPath.startsWith('/')?pending.returnPath:pending?.eventId?`${fallback}${pending.eventId}`:'/';const flag=params.get('nexi_cancel')==='1'?'nexi_cancel=1':'nexi_return=1';const sep=target.includes('?')?'&':'?';window.location.replace(`${target}${sep}${flag}`)}catch{window.location.replace('/')}
}

if(path==='/payment-return'&&params.get('payment_return')==='1'){
 try{const raw=sessionStorage.getItem('event-platform:sumup-pending');const pending=raw?JSON.parse(raw) as {returnPath?:string;eventId?:string}:null;const target=typeof pending?.returnPath==='string'&&pending.returnPath.startsWith('/e/')?pending.returnPath.split('?')[0]:pending?.eventId?`/e/${pending.eventId}`:'/e';window.location.replace(`${target}?payment_return=1`)}catch{window.location.replace('/e')}
}

type EntryKind = 'customer' | 'operator' | 'cashier'
const storageKey = (entry: EntryKind) => `event-platform:pwa:${entry}:event-id`

function rememberEvent(entry: EntryKind, eventId: string) {
  try { window.localStorage.setItem(storageKey(entry), eventId) } catch { /* restricted storage */ }
}
function recallEvent(entry: EntryKind) {
  try {
    const value = window.localStorage.getItem(storageKey(entry))
    return value && new RegExp(`^${UUID_PATTERN}$`, 'i').test(value) ? value : null
  } catch { return null }
}
function resolveEntryEvent(entry: EntryKind, basePath: string, specificMatch: RegExpMatchArray | null) {
  if (specificMatch) { rememberEvent(entry, specificMatch[1]); return specificMatch[1] }
  if (path === basePath || path === `${basePath}/`) {
    const remembered = recallEvent(entry)
    if (remembered) { window.history.replaceState(null, '', `${basePath}/${remembered}`); return remembered }
  }
  return null
}

const publicMatch = path.match(new RegExp(`^/e/(${UUID_PATTERN})/?$`, 'i'))
const operatorMatch = path.match(new RegExp(`^/operator/(${UUID_PATTERN})/?$`, 'i'))
const cashierMatch = path.match(new RegExp(`^/cassa/(${UUID_PATTERN})/?$`, 'i'))
const productionSettingsMatch = path.match(new RegExp(`^/production-settings/(${UUID_PATTERN})/?$`, 'i'))
const publicEventId = resolveEntryEvent('customer', '/e', publicMatch)
const operatorEventId = resolveEntryEvent('operator', '/operator', operatorMatch)
const cashierEventId = resolveEntryEvent('cashier', '/cassa', cashierMatch)
const isCustomerEntry = path === '/e' || path === '/e/'
const isOperatorEntry = path === '/operator' || path === '/operator/'
const isCashierEntry = path === '/cassa' || path === '/cassa/'

function EntryMissing({ label }: { label: string }) {
  return <main className="center-screen"><section className="panel"><div className="brand-mark">EP</div><p className="eyebrow">PWA multi-entry</p><h1>{label}</h1><p className="muted">Questa installazione non ha ancora un evento associato. Apri prima il link dell'evento per questa modalità e installa la PWA da quella pagina.</p><button className="primary" type="button" onClick={() => window.location.assign('/')}>Apri gestione eventi</button></section></main>
}

const operational=(content:React.ReactNode)=><>{content}<PwaInstallButton/></>
let app: React.ReactNode
if (publicEventId) {
  void applyEventPwaIdentity('customer',publicEventId)
  app = operational(<CustomerOrdering eventId={publicEventId} />)
} else if (operatorEventId) {
  void applyEventPwaIdentity('operator',operatorEventId)
  app = params.get('mode')==='order'
    ? operational(<CrossRoleOperations eventId={operatorEventId} mode="operator-order" />)
    : operational(<><EventOperatorApp eventId={operatorEventId} /><RoleActionLauncher eventId={operatorEventId} kind="operator" /></>)
} else if (cashierEventId) {
  void applyEventPwaIdentity('cashier',cashierEventId)
  app = params.get('mode')==='payments'
    ? operational(<CrossRoleOperations eventId={cashierEventId} mode="cashier-payments" />)
    : operational(<EventCashierStableApp eventId={cashierEventId} />)
} else if (productionSettingsMatch) {
  document.title = 'Event Platform · Produzione'
  app = <ProductionSettings eventId={productionSettingsMatch[1]} />
} else if (isCustomerEntry) app = <EntryMissing label="Cliente" />
else if (isOperatorEntry) app = <EntryMissing label="Operatore" />
else if (isCashierEntry) app = <EntryMissing label="Cassa" />
else { document.title = 'Event Platform · Gestione'; app = <App /> }

const root=document.getElementById('root')
if(root) ReactDOM.createRoot(root).render(<React.StrictMode>{app}</React.StrictMode>)
else document.body.innerHTML='<main style="font-family:Arial;padding:24px"><h1>Event Platform</h1><p>Errore caricamento interfaccia. Ricarica la pagina.</p></main>'
